import React, { useRef, useState, useEffect, useCallback } from 'react';
import "./VolumeSlider.css";
// NORTON DESIGN SYSTEM
// import { Button } from '@wwnds/react';

const VolumeSlider = ({ value, handleChange, volumeOpen, volumeBtnRef, sliderThumb, setVolumeOpen }) => {
  const [isThumbFocused, setIsThumbFocused] = useState(false)
  // Keyboard shortcuts
  const handleKeyPress = useCallback((event) => {
    if (event.keyCode === 38) {
      // up arrow clicked
      handleChange(value + 10 >= 100 ? 100 : value + 10)
    } else if (event.keyCode === 40) {
      // down arrow clicked
      handleChange(value - 10 <= 0 ? 0 : value - 10)
    }
    else if (event.keyCode === 9) {
      setVolumeOpen(false)
    }
  }, [handleChange, setVolumeOpen, value]);
  useEffect(() => {
    if (isThumbFocused) {
      document.addEventListener('keydown', handleKeyPress);
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      }
    }
  }, [isThumbFocused, handleKeyPress])

  useEffect(() => {
    if (volumeOpen && sliderThumb && sliderThumb.current) {
      console.log("set focus")
      if (volumeBtnRef && volumeBtnRef.current) {
        volumeBtnRef.current.blur();
      }
      sliderThumb.current.focus({ focusVisible: true });
    }
  }, [sliderThumb, volumeBtnRef, volumeOpen])

  const volumeTrackSliderRef = useRef(null)
  const handleMove = (e) => {
    document.onpointerup = (e) => {
      const pointerPos = e.pageX
      const boundaryLeft = volumeTrackSliderRef.current.getBoundingClientRect().left
      const boundaryWidth = volumeTrackSliderRef.current.offsetWidth
      const position = ((pointerPos - boundaryLeft) / boundaryWidth) * 100
      handleChange(position >= 100 ? 100 : position <= 0 ? 0 : position)
      document.onpointerup = null;
      document.onpointermove = null;
    }
    document.onpointermove = (e) => {
      const pointerPos = e.pageX
      const boundaryLeft = volumeTrackSliderRef.current.getBoundingClientRect().left
      const boundaryWidth = volumeTrackSliderRef.current.offsetWidth
      const position = ((pointerPos - boundaryLeft) / boundaryWidth) * 100
      handleChange(position >= 100 ? 100 : position <= 0 ? 0 : position)
    }
  }

  const handleTouchMove = (e) => {
    const touch = e.touches[0]
    const position = ((touch.pageX - volumeTrackSliderRef.current.getBoundingClientRect().left) / volumeTrackSliderRef.current.offsetWidth) * 100
    handleChange(position >= 100 ? 100 : position <= 0 ? 0 : position)
  }

  const handleClick = (e) => {
    const pointerPos = e.pageX
    const boundaryLeft = volumeTrackSliderRef.current.getBoundingClientRect().left
    const boundaryWidth = volumeTrackSliderRef.current.offsetWidth
    const position = ((pointerPos - boundaryLeft) / boundaryWidth) * 100
    handleChange(position >= 100 ? 100 : position <= 0 ? 0 : position)
  }

  return (
    <div className="volume-slider-container"
      role="slider"
      aria-label="volume slider in percentage"
      aria-valuenow={value >= 100 ? 100 : value <= 0 ? 0 : Math.round(value)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuetext={`Volume, ${value >= 100 ? 100 : value <= 0 ? 0 : Math.round(value)}%`}
    >
      <div className="volume-slider-heading">Volume: <span className="volume-slider-heading-value-span">{Math.round(value)}%</span></div>
      <div className="volume-slider-track-container"
        ref={volumeTrackSliderRef}
        onTouchMove={(e) => handleTouchMove(e)}
        onClick={(e) => handleClick(e)}
      >
        <div className="volume-slider-track"></div>
        <div className="volume-slider-track-elapsed" style={{
          width:
            `${value >= 100 ? 100 : value}%`
        }}></div>
        <div
          tabIndex={0}
          className="volume-slider-thumb"
          ref={sliderThumb}
          style={{ left: `calc(${value >= 100 ? 100 : value}% - 7px` }}
          onPointerDown={handleMove}
          onFocus={() => setIsThumbFocused(true)}
          onBlur={() => setIsThumbFocused(false)}
        ></div>
      </div>
      <div className="volume-slider-footer">
        {/* <Button aria-label="Decrease volume 10 percent" baseName="volume-change-btn" variant="ghost" onClick={() => handleChange(value - 10 >= 100 ? 100 : value - 10 <= 0 ? 0 : value - 10)}>&minus;</Button>
        <Button aria-label="Increase volume 10 percent" baseName="volume-change-btn" variant="ghost" onClick={() => handleChange(value + 10 >= 100 ? 100 : value + 10 <= 0 ? 0 : value + 10)}>+</Button> */}
        <span className="volume-change-span">&minus;</span>
        <span className="volume-change-span">+</span>
      </div>
    </div>
  )
}

export default VolumeSlider;